<template>
  <div
    class="bg-white rounded-xl shadow-lg p-4 hover:shadow-xl transition-all duration-300 border border-gray-100"
  >
    <div class="flex items-center justify-between mb-3">
      <div class="text-[#FF5722] bg-[#FF5722] bg-opacity-10 p-2 rounded-lg">
        <VendingIcon class="text-xl" />
      </div>
      <div
        :class="[
          'px-2 py-1 rounded-full text-xs flex items-center gap-1.5',
          connectionStatus
            ? 'bg-green-100 text-[#4CAF50]'
            : 'bg-red-100 text-[#F44336]'
        ]"
      >
        <span
          class="w-1.5 h-1.5 rounded-full"
          :class="connectionStatus ? 'bg-[#4CAF50]' : 'bg-[#F44336]'"
        ></span>
        {{
          connectionStatus
            ? $t("vendings.filterOnline")
            : $t("vendings.filterOffline")
        }}
      </div>
    </div>

    <div class="space-y-2">
      <div class="flex items-center gap-2">
        <h3 class="text-lg font-semibold text-[#4A4453]">{{ vendingName }}</h3>
        <span class="material-icons text-[#FF5722] text-sm">fingerprint</span>
      </div>

      <div class="space-y-2 text-sm text-[#4A4453] mt-3">
        <div class="flex items-center gap-2 bg-gray-50 p-2 rounded-lg">
          <span class="material-icons text-[#FF5722] text-sm">location_on</span>
          <span class="opacity-80 line-clamp-1">{{ location }}</span>
        </div>
        <div class="flex items-center gap-2 bg-gray-50 p-2 rounded-lg">
          <span class="material-icons text-[#FF5722] text-sm">update</span>
          <span class="opacity-80"
            >{{
              connectionStatus
                ? $t("vendings.onlineSince")
                : $t("vendings.offlineSince")
            }}
            {{
              lastConnection
                ? moment(lastConnection).format("DD/MM/YY HH:mm:ss")
                : ""
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VendingIcon from "../icons/VendingIcon.vue";

export default {
  name: "VendingMachineCard",
  components: {
    VendingIcon
  },
  props: {
    vendingName: {
      type: String,
      required: true
    },
    address: {
      type: Object,
      required: true
    },
    lastConnection: {
      type: [String, null],
      default: null
    },
    connectionStatus: {
      type: [Boolean, null],
      required: true
    }
  },
  computed: {
    location() {
      return `${this.address.street}, ${this.address.number} - ${this.address.neighborhood}, ${this.address.city} - ${this.address.state}`;
    }
  }
};
</script>
